import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex-container-row justify-between align-center" }
const _hoisted_2 = ["checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bool_field = _resolveComponent("bool-field")!

  return (_ctx.rowType != 'groupHeader')
    ? (_openBlock(), _createElementBlock("td", {
        key: 0,
        class: _normalizeClass(_ctx.className)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("input", {
            type: "checkbox",
            checked: _ctx.propValue,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onCheckBoxChange(_ctx.dataItem, $event.target.checked)))
          }, null, 40, _hoisted_2)
        ])
      ], 2))
    : (_ctx.isGroupRender)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          style: _normalizeStyle({color: _ctx.propValue ? 'red' : 'green'})
        }, [
          _createVNode(_component_bool_field, {
            value: _ctx.sourceValue,
            format: "yesNo"
          }, null, 8, ["value"])
        ], 4))
      : _createCommentVNode("", true)
}